import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';
import { matomoTracker } from "./matomo";


export const useLogMatomoEvent = () => {
  const { pushInstruction } = useMatomo();
  const correlationId = sessionStorage.getItem("correlationId");
    useEffect(() => {
    if (correlationId) {
      matomoTracker.pushInstruction('setUserId', correlationId);
    }
  }, [correlationId, pushInstruction]);

  return (
    category: string,
    action: string,
    name?: string,
    value?: number
  ) => {
    matomoTracker.trackEvent({ category, action, name, value });
  };
};



